/**
 * Applies transparency to provided hex color string 2
 * @param color 6 letter string hex value for the color to apply transparency to (Example: '#ff0000')
 * @param transparencyFloat Number between 0 and 1 corresponding to desired transparency level.
 * @returns Returns a 8 letter string hex value composed of initially provided color + generated transparency.
 */
const mbApplyTransparency = (color: string, transparencyFloat: number): string => {
  if (transparencyFloat < 0 || transparencyFloat > 1) {
    return color;
  }

  let transparencyHex = Math.floor(transparencyFloat * 255).toString(16);
  if (transparencyHex.length === 1) {
    transparencyHex = '0' + transparencyHex;
  }

  return color + transparencyHex;
};

export { mbApplyTransparency };
